export const locale = {
    lang: 'vn',
    data: {
        APP_SWITCHER: {
            PERSONEL_MANAGEMENT: 'QUẢN LÝ NHÂN SỰ',
            ACCOUNTANT: 'KẾ TOÁN'
        }
    }
};
